import type { Page } from "../types";
import { useI18n } from "../i18n";

const navigation: Array<{
  page: Page;
  icon: string;
  key:
    | "nav.dashboard"
    | "nav.meetings"
    | "nav.calendar"
    | "nav.translate"
    | "nav.skills"
    | "nav.search"
    | "nav.settings"
    | "nav.privacy";
}> = [
  { page: "dashboard", icon: "⌂", key: "nav.dashboard" },
  { page: "meetings", icon: "◉", key: "nav.meetings" },
  { page: "calendar", icon: "□", key: "nav.calendar" },
  { page: "translate", icon: "文", key: "nav.translate" },
  { page: "skills", icon: "✦", key: "nav.skills" },
  { page: "search", icon: "⌕", key: "nav.search" },
  { page: "settings", icon: "⚙", key: "nav.settings" },
  { page: "privacy", icon: "◇", key: "nav.privacy" },
];

export function Sidebar({
  page,
  onNavigate,
}: {
  page: Page;
  onNavigate: (page: Page) => void;
}): React.JSX.Element {
  const { t } = useI18n();
  return (
    <aside className="sidebar">
      <div className="brand">
        <span className="brand-mark">D</span>
        <div>
          <strong>{t("app.name")}</strong>
          <small>{t("app.tagline")}</small>
        </div>
      </div>
      <nav aria-label="Primary navigation">
        {navigation.map((item) => (
          <button
            key={item.page}
            type="button"
            className={page === item.page ? "active" : ""}
            onClick={() => onNavigate(item.page)}
          >
            <span aria-hidden="true">{item.icon}</span>
            {t(item.key)}
          </button>
        ))}
      </nav>
      <div className="local-card">
        <span aria-hidden="true">●</span>
        <div>
          <strong>{t("nav.local")}</strong>
          <small>{t("nav.localDetail")}</small>
        </div>
      </div>
      <div className="profile">
        <div className="avatar">ME</div>
        <div>
          <strong>{t("nav.workspace")}</strong>
          <small>{t("nav.plan")}</small>
        </div>
      </div>
    </aside>
  );
}
